/* eslint-disable react/default-props-match-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import SelectControl, { AsyncCreatable } from 'react-select';
import SelectStyler from './SelectStyler';

const Select = props => (
  <SelectStyler className={props.className} invalid={props.invalid}>
    {props.loadOptions ? (
      props.chips ? (
        <AsyncCreatable clearable={false} {...props} />
      ) : (
        <SelectControl.Async clearable={false} {...props} />
      )
    ) : props.chips ? (
      <div>
        <span>creatable</span>
        <SelectControl.Creatable {...props} />
      </div>
    ) : (
      <SelectControl clearable={false} {...props} />
    )}
  </SelectStyler>
);

Select.propTypes = {
  chips: PropTypes.bool,
  className: PropTypes.string,
  invalid: PropTypes.bool,
  loadOptions: PropTypes.func
};

Select.defaultProps = {
  chips: false,
  displayKey: 'display',
  valueKey: 'value'
};

export default Select;
